export function mdLinkToHTML(md: string, target?: string) {
  const anchorTarget = target ? ` target="${target}"` : '';
  return md.replace(
    /\[([^\]]+)]\(([^(]+?)\)/g,
    `<a href="$2"${anchorTarget}>$1</a>`,
  );
}
